/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import * as Yup from 'yup';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Input from '../../../../shared/_TBComponents/Input/index';
import Iframely from './Iframely';
import DragDropVideoEmbed from './DragAndDropVideoEmbed';
import { setIframelyError, setActiveSecondLayerModal } from '../../ducks/calendarActions';

const NoVideoContainer = styled('div')`
  display: flex;
  border-radius: 4px;
  ${(props) => props.urlButtonValue === 'url' && 'border: 1px solid #EEEEEE'};
  height: 250px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: #FCFCFC;
`;

const VideoAndUrlContainer = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
 min-width: ${(props) => (props.containerWidth < 400
    ? '250px'
    : props.containerWidth >= 528 && props.containerWidth < 700
      ? '250px'
      : '350px')};
${(props) => (props.containerWidth >= 700 && 'max-width: 350px')};
`;

const VideoTypeContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const VideoTypeLabel = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #444444;
`;

const UrlAndUploadButtonContainer = styled('div')`
  display: flex;
  border-radius: 4px;
  border: 2px solid #EEEEEE;
`;

const URLButton = styled('div')`
  display: flex;
  height: 36px;
  width: 100%;
  background: ${(props) => (props.buttonValue === 'url' ? 'white' : '#EEEEEE')};
  border: ${(props) => (props.buttonValue === 'url' ? '2px solid #77A7FF' : '2px solid #EEEEEE')};
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  transition: ${TransitionGlobal};
`;

const GoldAccessLevelBadge = styled('div')`
  position: absolute;
  top: -13px;
  right: -12px;
  padding-right: 16px;
  padding-left: 16px;
  padding-top: 2px;
  background: #FFCB47;
  border-radius: 4px; 
  pointer-events: none !important;
`;

const UploadButton = styled('div')`
  display: flex;
  height: 36px;
  background: ${(props) => (props.buttonValue === 'upload' ? 'white' : '#EEEEEE')};
  border: ${(props) => (props.buttonValue === 'upload' ? '2px solid #77A7FF' : '2px solid #EEEEEE')};
  border-radius: 4px;
  width: 100%;
  justify-content: center;
  align-items: center;
  transition: ${TransitionGlobal};
`;

const URLButtonContainer = styled('div')`
  position: relative;
  display: flex;
  height: 36px;
  background: ${(props) => (props.buttonValue === 'url' ? 'white' : '#EEEEEE')};
  width: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: ${TransitionGlobal};
`;

const UploadButtonContainer = styled('div')`
  position: relative;
  display: flex;
  height: 36px;
  background: ${(props) => (props.buttonValue === 'upload' ? 'white' : '#EEEEEE')};
  width: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: ${(props) => (props.currentUserAccessLevel < 4 ? 1 : '0.7')};
  }
`;

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  position: relative;
`;

const EditThumbnailButtonContainer = styled('div')`
  display: flex;
  gap: 4px;
  cursor: pointer;
  align-items: center;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const DeleteAndEditContainer = styled('div')`
  display: flex;
  gap: 4px;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
`;

const DeleteIconWrapper = styled('div')`
  display: flex;
  cursor: pointer;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const URLandTrashContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const VideoAndUrlInput = ({
  errors,
  touched,
  videoUrlValue,
  mediaUrlValue,
  setFieldValue,
  urlButtonValue,
  containerWidth,
  setFieldTouched,
  setFieldError,
  isDisabled,
}) => {
  const dispatch = useDispatch();
  const iframelyError = useSelector((state) => state.calendar.data.iframelyError);
  const [urlToEmbed, setUrlToEmbed] = useState('');
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const currentUserAccessLevel = currentUser?.organizationAccessLevel;

  const urlValidationSchema = Yup.string().url('Must be a valid URL').nullable(true);

  const validateUrlAndSetUrlToEmbed = async (value) => {
    try {
      /** Validate the URL using the Yup schema then then
      setUrlToEmbed only if valid url */
      setFieldTouched('videoUrl', true);
      const validatedValue = await urlValidationSchema.validate(value);
      setUrlToEmbed(validatedValue);
    } catch (err) {
      dispatch(setIframelyError(null));
      setFieldError('videoUrl', err.message);
    }
  };

  /** This set timeout is waiting for a 500 mil sec pause when videoUrl changes
   * this helps so that if a user is typing a url, the iframely validateUrlSetUrlToEmbed
   * fuction won't fire on evey single character, it will wait for a paus in the user's typeing
   */
  useEffect(() => {
    if (videoUrlValue) {
      const timeoutId = setTimeout(() => validateUrlAndSetUrlToEmbed(videoUrlValue), 500);
      return () => clearTimeout(timeoutId);
    }
    return () => {};
  }, [videoUrlValue]);

  return (
    <VideoAndUrlContainer containerWidth={containerWidth}>
      {!isDisabled && (
      <VideoTypeContainer>
        <VideoTypeLabel>Instructional Video</VideoTypeLabel>
        <UrlAndUploadButtonContainer>
          <URLButtonContainer>
            <URLButton
              buttonValue={urlButtonValue}
              onClick={() => {
                setFieldValue('mediaUrl', null);
                setFieldValue('mediaId', null);
                setFieldValue('uploadOrUrl', 'url');
              }}
            >
              <Text color={urlButtonValue === 'url' ? '#444444' : '#9E9E9E'} fontSize='13px'>URL</Text>
            </URLButton>
          </URLButtonContainer>
          <UploadButtonContainer>
            <UploadButton
              currentUserAccessLevel={currentUserAccessLevel}
              buttonValue={urlButtonValue}
              onClick={() => {
                if (currentUserAccessLevel < 4) {
                  dispatch(setActiveSecondLayerModal('premiumFeatureUploadVideoModal'));
                } else {
                  dispatch(setIframelyError(null));
                  setFieldValue('videoUrl', null);
                  setUrlToEmbed(null);
                  setFieldValue('uploadOrUrl', 'upload');
                }
              }}
            >
              <Text color={urlButtonValue === 'upload' ? '#444444' : '#9E9E9E'} fontSize='13px'>Upload</Text>
              {currentUserAccessLevel < 4 && (
              <GoldAccessLevelBadge>
                <Text fontWeight={700} fontSize='13px'>Gold</Text>
              </GoldAccessLevelBadge>
              )}
            </UploadButton>
          </UploadButtonContainer>
        </UrlAndUploadButtonContainer>
      </VideoTypeContainer>
      )}
      {urlButtonValue === 'url' && (
      <URLandTrashContainer>
        <Input
          disabled={isDisabled}
          top='38px'
          error={(!!touched.videoUrl && !!errors.videoUrl) || (!!touched.videoUrl && iframelyError)}
          errorMsg={errors.videoUrl}
          fontSize='16px'
          fontWeight={400}
          textColor='#444444'
          height='38px'
          label='Video URL'
          name='videoUrl'
          right='5px'
          styledPropsLabel={{
            fontSize: '16px',
            fontWeight: 700,
          }}
          value={videoUrlValue}
          width='100%'
          onChange={(e) => {
            const { value } = e.target;
            setFieldValue('videoUrl', value);
            if (!value) {
              dispatch(setIframelyError(null));
            }
          }}
          placeholder='Enter video url below (ex. YouTube, Vimeo'
        />
        {videoUrlValue && !isDisabled && (
        <DeleteIconWrapper
          style={{ marginTop: '29px' }}
          onClick={() => {
            setFieldValue('videoUrl', '');
            dispatch(setIframelyError(null));
            setUrlToEmbed(null);
          }}
        >
          <IcomoonReact
            iconSet={iconSet}
            size={16}
            icon='delete'
            color='#9E9E9E'
          />
        </DeleteIconWrapper>
        )}
      </URLandTrashContainer>
      )}
      {urlButtonValue === 'url' ? (
        <NoVideoContainer urlButtonValue={urlButtonValue}>
          {urlToEmbed && !errors.videoUrl && videoUrlValue ? (
            <Iframely url={urlToEmbed} setFieldValue={setFieldValue} />
          ) : (
            <>
              <IconContainer>
                <IcomoonReact
                  iconSet={iconSet}
                  size={30}
                  icon='no-video'
                  color='#9E9E9E'
                />
              </IconContainer>
              <Text fontSize='19px' color='#9E9E9E'>No Video</Text>
            </>
          )}
        </NoVideoContainer>
      ) : (
        <NoVideoContainer urlButtonValue={urlButtonValue}>
          <DragDropVideoEmbed mediaUrlValue={mediaUrlValue} setFieldValue={setFieldValue} />
        </NoVideoContainer>
      )}
      {urlButtonValue === 'upload' && mediaUrlValue && (
      <DeleteAndEditContainer>
        <EditThumbnailButtonContainer onClick={() => dispatch(setActiveSecondLayerModal('addThumbnail'))}>
          <IcomoonReact
            iconSet={iconSet}
            size={16}
            icon='gallery'
            color='#77A7FF'
          />
          <Text style={{ borderBottom: '1px solid' }} fontSize='16px' color='#77A7FF'>Edit Thumbnail</Text>
        </EditThumbnailButtonContainer>
        <DeleteIconWrapper onClick={() => setFieldValue('mediaUrl', null)}>
          <IcomoonReact
            iconSet={iconSet}
            size={16}
            icon='delete'
            color='#9E9E9E'
          />
        </DeleteIconWrapper>
      </DeleteAndEditContainer>
      )}
    </VideoAndUrlContainer>

  );
};

export default VideoAndUrlInput;
